class CustomError extends Error {}

export default CustomError;
